import { ziggyRoutes } from './localeUrl';

/* The languages the site offers, in the order they are shown.

   One list, because the switcher is rendered twice: the rail that runs down the
   right edge of the page and the row inside the collapsed header menu. Before
   this existed each copy spelled the three codes and names out for itself, so a
   fourth language would have been added in one place and silently missing from
   the other.

   Three display lengths, because the three places that name a language have three
   different amounts of room, and pulling one string through all of them is how a
   label ends up wrong for two of the three:

     name       the full endonym, for the chooser. A reader picking a language
                should not have to decode an abbreviation to do it, so this is
                the one place the whole name is spelled out.
     shortName  the rail. A rotated strip has room for a shorter form, and only
                Malay differs: `Bahasa` alone means "language", so the endonym is
                `Bahasa Melayu`, but the rail's three-entry strip reads fine
                without the qualifier while the chooser does not.
     abbr       the two-letter mark the header row puts in its right column,
                where the rows above carry a two-digit index.

   Every name is an endonym: a language is named in its own language, so none of
   them changes with the locale that is currently active. There is no trailing
   punctuation either; the rail supplies its own separators.

   `localeHref` is the switch. It is a real URL of the same page in the other
   language, which is what a crawler follows. `switchLocale` remains for the
   signed automation preview only: that path is the signature, so it cannot
   change, and the control there still repaints in place. */
export const LOCALES = [
  { code: 'en-MY', name: 'English', shortName: 'English', abbr: 'EN' },
  { code: 'ms-MY', name: 'Bahasa Melayu', shortName: 'Bahasa', abbr: 'BM' },
  { code: 'zh-MY', name: '简体中文', shortName: '简体中文', abbr: 'CH' }
];

const PREFIX = {
  'ms-MY': 'ms',
  'zh-MY': 'zh'
};

/* `/web-design` is registered as `web-design.en` so the route cache can keep
   the public name on the prefixed copy. The switcher still addresses that
   public name. */
function pageName(name) {
  if (typeof name === 'string' && name.slice(-3) === '.en') {
    return name.slice(0, -3);
  }

  return name;
}

export function switchLocale(vm, code) {
  vm.$i18n.global.locale.value = code;
}

/* The same page in another language, or null when this URL has no language
   prefix to swap. A blog article is the one public page in that second group
   that still has a sensible destination: the listing, which is translated.
   The signed preview returns null and keeps the in-place switch. */
export function localeHref(code) {
  const routes = ziggyRoutes();

  if (typeof route !== 'function' || !routes) {
    return null;
  }

  const current = route();
  const name = pageName(current.current());
  const definition = name && routes[name];

  if (!definition || typeof definition.uri !== 'string') {
    return null;
  }

  const prefix = PREFIX[code] || '';

  if (definition.uri.indexOf('{locale') === -1) {
    if (name === 'blog.show') {
      return route('blog.index', { locale: prefix });
    }

    return null;
  }

  const params = Object.assign({}, current.params);

  params.locale = prefix;

  return route(name, params);
}
